import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import XLSX_STYLE from 'xlsx-js-style';
import ExportExcelTemplate from './ExportContractExcelTemplate';

export default {
    computed: {
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
        }),
    },
    data() {
        return {
            isLoadingExport: false,
            prevQuery: [],
        };
    },
    methods: {
        async onExport() {
            const wb = XLSX_STYLE.utils.book_new();

            try {
                this.isLoadingExport = true;
                const details = await this.getExportData('/LoanReceipt/GetLoanReceiptList');

                const ws = this.getExcelSheet(details);

                XLSX_STYLE.utils.book_append_sheet(wb, ws, '借款管理總覽');
                XLSX_STYLE.writeFile(wb, `借款管理總覽-${moment().format('YYYYMMDD')}.xlsx`);
            } catch (e) {
                console.log(e);
                this.$message({
                    showClose: true,
                    message: '無資料可匯出',
                    type: 'error',
                });
            } finally {
                this.isLoadingExport = false;
            }
        },
        getExportDataRows(deatils) {
            return _.map(deatils, (o) => ({
                A: o.systemNo,
                B: o.title,
                C: o.amortizationAmount,
                D: o.amortizationRate !== null ? `${o.amortizationRate}%` : '---',
                E: o.amortizationPeriods,
                F: o.statistics.amortizationRepaymentTotalAmount,
                G: this.getAmortizationPercentage(o),
                H: o.statistics.amortizationDrawdownTotalAmount - o.statistics.amortizationRepaymentTotalAmount,
                I: o.amortizationEndDate ? moment(o.amortizationEndDate).format('YYYY-MM-DD') : '---',
                J: o.repaymentAmount,
                K: o.repaymentRate ? `${o.repaymentRate}%` : '---',
                L: o.repaymentPeriods ? o.repaymentPeriods : '---',
                M: o.repaymentAmount - (o.statistics.revolvingDrawdownTotalAmount - o.statistics.revolvingRepaymentTotalAmount),
                N: o.repaymentEndDate ? moment(o.repaymentEndDate).format('YYYY-MM-DD') : '---',
            }));
        },
        getExcelSheet(deatils) {
            const DATA = this.getExportDataRows(deatils);
            console.log(DATA);

            const sheet = _.cloneDeep(ExportExcelTemplate);

            XLSX_STYLE.utils.sheet_add_json(sheet, DATA, { skipHeader: true, origin: 'A3' });

            const widthSettings = [15, 40, 15, 10, 10, 15, 10, 15, 10, 15, 10, 13, 15, 10];
            sheet['!cols'] = _.map(widthSettings, (h) => ({ wch: h }));

            _.forEach(sheet, (value, key) => {
                if (!key.includes('!')) {
                    const COL = key.substring(0, 1);
                    const ROW = Number(key.substring(1));

                    if (sheet[key].s) {
                        sheet[key].s.border = {
                            bottom: { style: 'thin', color: 'FFFFFFFF' },
                            top: { style: 'thin', color: 'FFFFFFFF' },
                            left: { style: 'thin', color: 'FFFFFFFF' },
                            right: { style: 'thin', color: 'FFFFFFFF' },
                        };
                    } else {
                        sheet[key].s = {
                            border: {
                                bottom: { style: 'thin', color: 'FFFFFFFF' },
                                top: { style: 'thin', color: 'FFFFFFFF' },
                                left: { style: 'thin', color: 'FFFFFFFF' },
                                right: { style: 'thin', color: 'FFFFFFFF' },
                            },
                        };
                    }

                    if (ROW > 1) {
                        if (COL === 'A' || COL === 'B') sheet[key].s.alignment = { horizontal: 'left' };
                        else sheet[key].s.alignment = { horizontal: 'right' };
                    }

                    // 設定金額格式
                    if (COL === 'C' || COL === 'F' || COL === 'H' || COL === 'J' || COL === 'M') sheet[key].z = '#,##0_-;-#,##0_-;0;General';
                }
            });

            return sheet;
        },

        async getExportData(apiUrl) {
            const PageSize = 1000;
            let PageNum = 1;
            const url = `${apiUrl}`;

            const { data } = await this.$api({
                url,
                method: 'GET',
                params: { PageNum: 1, PageSize },
            });

            // 足夠的PageSize
            if (PageSize > data.totalNum) {
                return data.items;
            }

            const currentList = [...data.items];
            for (let i = 0; i < Math.ceil(data.totalNum / PageSize) - 1; i += 1) {
                PageNum += 1;
                // eslint-disable-next-line no-await-in-loop
                const resp = await this.$api({
                    url,
                    method: 'GET',
                    params: { PageNum, PageSize },
                });
                currentList.push(...resp.data.items);
            }
            return currentList;
        },
        getAmortizationPercentage(row) {
            const p = Math.round((row.statistics.amortizationRepaymentTotalAmount / row.statistics.amortizationDrawdownTotalAmount) * 100);
            return `${p || 0}%`;
        },
    },
};
